import { AlertService } from './alert.service';
import { ConfigurationService } from './configuration.service';
import { DOCUMENT } from '@angular/common';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { ContactUsModel } from '../models/contactus.model';
import { ManualClaimProfile } from '@app/models/manual-claim-profile.model';
import { ContentDetailReturnModel } from '@app/models/content-detail-return.model';
import { ContentDetailSectionModel } from '@app/models/content-detail.model.';
import { ContentPageActions } from '@app/models/enums';

@Injectable({
  providedIn: 'root'
})

export class RankipediaService {

  private xxloginRedirectUrl: string;

  protected httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        Accept: 'application/json, text/plain, */*'
    })
      , withCredentials: true
    };

  constructor(
    protected http: HttpClient,
    private router: Router,
    private configurations: ConfigurationService,
    private alertService: AlertService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  submitFeedback(contactmodel: ContactUsModel): Observable<any> {
    const urlPost = this.configurations.homeApiUrl + '/SubmitFeedback';
    const data = JSON.stringify(contactmodel);
    return this.http.post<any>(urlPost, data, this.httpOptions);
  }

  manualClaimProfile(manualClaim: ManualClaimProfile): Observable<any> {
    const urlPost = this.configurations.homeApiUrl + '/ManualClaimProfile';
    const data = JSON.stringify(manualClaim);
    return this.http.post<any>(urlPost, data, this.httpOptions);
  }

  getNarrativeText(key) {
    return this.http.get('/home/getNarrativeByKeyUI?key=' + key);
  }

  getContentDetails(key) {
    return this.http.get<any>('/content/getContentDetails?key=' + key);
  }

  getContentSections(contentId, sections : ContentDetailSectionModel[]) {
    const url = '/content/getContentSections?contentId=' + contentId;
    return this.http.post<any>(url, { contentId: contentId, sectionMetaData: sections }, this.httpOptions);
  }

  updateContentView(contentId) {
    return this.http.get('/content/getContentPage?contentId=' + contentId);
  }

  updateContentAction(key, action: ContentPageActions, id: number) {
    return this.http.get('/content/UpdateContentAction?contentKey=' + key + '&updateType=' + action + '&id=' + id);
  }
}
